import { render, staticRenderFns } from "./announcer.vue?vue&type=template&id=dc625038&scoped=true"
import script from "./announcer.vue?vue&type=script&lang=js"
export * from "./announcer.vue?vue&type=script&lang=js"
import style0 from "./announcer.vue?vue&type=style&index=0&id=dc625038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc625038",
  null
  
)

export default component.exports